import { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Formik } from 'formik';

import Sidebar from "../../../../../components/Sidebar";
import Button from "../../../../../components/Button";
import Input from "../../../../../components/FormikForm/Input";
import TextArea from '../../../../../components/FormikForm/TextArea';
import Submit from "../../../../../components/FormikForm/Submit";
import Snackbar from "../../../../../components/Snackbar";

import { initialValues, schema } from '../../../../../constants/forms/category/edit'

import { createCategory, resetNewCategory } from '../../../../../store/actions/category'
import { CategoryDto } from '../../../../../types/category';
import { Group } from '../../../../../types';

interface ComponentProps {
  group: Group
  groupStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
  newCategory: CategoryDto;
  newCategoryStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
  onClose: any
  isVisible: boolean
}

const Component = ({
  group,
  groupStates,
  newCategory,
  newCategoryStates,
  onClose,
  isVisible
}: ComponentProps) => {
  const dispatch = useDispatch();
  const [actions, setActions] = useState<{ resetForm: () => void }>()
  const [formSubmmited, setFormSubmmited] = useState(false);

  const onSubmit = ({ values, actions }) => {
    setActions(actions)
    dispatch(createCategory({ ...values, group_id: group?.id }));
  };

  useEffect(() => {
    if (newCategoryStates.success) {
      !!onClose && onClose(false);
      actions?.resetForm()
      setTimeout(() => {
        dispatch(resetNewCategory());
      }, 3500);
    }
  }, [newCategoryStates]);

  return <>
    <Sidebar
      position="right"
      visible={isVisible}
      closeType="back"
      onClose={() => {
        !!onClose && onClose(false);
      }}
      width="463px"
      title="Nueva categoría"
    >
      <Formik
        initialValues={{ ...initialValues }}
        onSubmit={(values, actions) => {
          if (onSubmit) onSubmit({ values, actions });
        }}
        validateOnChange={false}
        validateOnBlur={formSubmmited}
        validationSchema={schema}
        enableReinitialize
      >
        {({
          touched,
          errors,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
        }) => {
          return (
            <form
              className="theme-form"
              onSubmit={(event) => {
                setFormSubmmited(true);
                handleSubmit(event);
              }}
              id="new-category-form"
            >
              <Input
                name="name"
                error={errors["name"]}
                touched={touched["name"]}
                step="any"
                placeholder="Sin espacios"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values["name"]}
                options={{
                  label: "Nombre de la categoría",
                  helperText:
                    "No debe contener espacios o caracteres especiales.",
                  marginBottom: 40,
                }}
              />

              <TextArea
                name="description"
                error={errors["description"]}
                touched={touched["description"]}
                value={values["description"]}
                step="any"
                placeholder="Ej: 10"
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={200}
                options={{
                  label: "Descripción de la cateogoría",
                  marginBottom: 40,
                }}
              />
            </form>
          );
        }}
      </Formik>

      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <Button
          disabled={newCategoryStates.loading}
          options={{
            type: "outline",
            size: "lg",
            skin: "purple",
          }}
          onClick={() => onClose()}
        >
          Cancelar
        </Button>

        <Submit
          isSubmmiting={newCategoryStates.loading}
          options={{
            type: "filled",
            size: "lg",
            skin: "purple",
          }}
          form="new-category-form"
        >
          Crear categoría
        </Submit>
      </div>
    </Sidebar>

    <Snackbar
      visible={newCategoryStates.success || !!newCategoryStates.error}
      options={{
        time: 2000,
        type: newCategoryStates.success ? "success" : "error",
      }}
    >
      {newCategoryStates.success
        ? "Categoría creada."
        : "Error al crear la categoría."}
    </Snackbar>
  </>
}

const state = ({ groupStore, categoryStore }) => {
  const { data: categories, states: categoriesState } =
    categoryStore?.allCategories;
  const { data: group, states: groupStates } =
    groupStore.group;
  const { data: newCategory, states: newCategoryStates } = categoryStore.newCategory;

  return {
    group,
    groupStates,
    categories,
    categoriesState,
    newCategory,
    newCategoryStates,
  };
};

export default connect(state)(Component);